import { Regions } from '@wicadu/langscope'

import globalTranslations from '@translations/pages/legal/home/global'

export const LEGAL_HOME_TRANSLATIONS = {
  [Regions.Global]: globalTranslations,
} as const
